__turbopack_context__.v({
  "referenceLink": "SyuTya_referenceLink",
  "text": "SyuTya_text",
});
